@use "src/sedestral/sass/mixins/texts";
@use "src/sedestral/sass/icons/icons";

.componentOfferBlocked {
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 10px;

  > .title {
    font-size: 22px;
    max-width: calc(100% - 50px);

    @include texts.font("bold");
  }

  .description {
    font-size: 15px;
    margin-bottom: 8px;
  }

  .content {
    border-radius: 10px;
    border: 1px solid rgba(58, 111, 243, 0.22);
    padding: 25px;
    background: linear-gradient(180deg, rgba(58, 111, 243, 0.1) 0%, rgba(58, 111, 243, 0.3) 50%, rgba(58, 111, 243, 0.1) 100%);
    position: relative;
    padding-bottom: 90px;

    .title {
      font-size: 18px;
      margin-bottom: 20px;

      @include texts.font("bold");
    }

    .entries {
      display: flex;
      flex-direction: column;
      gap: 15px;

      .entry {
        font-size: 15px;
        display: flex;
        align-items: center;
        gap: 12px;

        .icon {
          height: 12px;
          width: 12px;
          flex: 0 0 12px;
          filter: var(--icon-web-blue);
          position: relative;

          @include icons.ico("black-checked");
        }
      }
    }

    .illus {
      width: 160px;
      height: 90px;
      right: 0;
      bottom: 0;
      position: absolute;

      @include icons.ico("illus-offer-blocked-progress");
    }

    .cases {
      position: absolute;
      right: -25px;
      bottom: 92px;
      gap: 10px;
      display: flex;
      flex-direction: column;

      .case {
        height: 50px;
        width: 50px;
        background: var(--white);
        border-radius: 15px;
        box-shadow: 0 0 25px 0 rgba(0, 0, 0, 0.20);
        display: flex;
        align-items: center;
        justify-content: center;

        .icon {
          height: 30px;
          width: 30px;

          &.google {
            @include icons.ico("colored-google");
          }
        }
      }
    }
  }

  .reviewsContainer {
    display: flex;
    margin-bottom: 15px;
    border: 1px solid var(--grey-sur);
    padding: 8px;
    align-items: center;
    border-radius: 12px;
    font-size: 14px;
    color: var(--grey-text-very-very-dark);

    .reviews {
      margin-left: auto;
      display: flex;
      align-items: center;
      gap: 8px;

      .trust {
        width: 68px;
        height: 28px;

        @include icons.ico("colored-trustpilot");
      }

      .view {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 4px;
        font-size: 12px;
        color: var(--web-blue);

        @include texts.font("semi-bold");

        .icon {
          height: 12px;
          width: 12px;
          transform: rotate(-45deg);
          filter: var(--icon-web-blue);

          @include icons.ico("black-right-arrow");
        }


      }
    }
  }

  .buttons {
    display: flex;
    gap: 15px;
    align-items: center;

    .button {
      background: var(--black);
      color: var(--white);
      font-size: 15px;
      display: flex;
      align-items: center;
      gap: 12px;
      width: fit-content;
      padding: 13px 15px;
      border-radius: 50px;
      cursor: pointer;

      &:hover {
        opacity: 0.8;
      }

      .arrow {
        height: 14px;
        width: 14px;
        filter: var(--icon-white);
        transform: rotate(-45deg);

        @include icons.ico("black-right-arrow");
      }
    }

    .text {
      max-width: 260px;
      font-size: 13px;

      span {
        @include texts.font("semi-bold");
      }
    }
  }
}